export default {
    dispatch(component,name, detail) {
        component.dispatchEvent &&
            component.dispatchEvent(new CustomEvent(name, { detail }));
    },

    dispatchCustomEvent(component, event, eventName, data){
        let detail = data || {};
        if(event && event.type && event.target ) {
            detail = {
                type: event.type,
                target: event.target
            }
            if(!eventName){
                eventName = event.type
            }
        }
        this.dispatch(component, eventName, detail);
    },

}